import axios from '../../admin-axios';
import { detectError } from '../../utils';
import ActionType from '../action-types';

// eslint-disable-next-line import/prefer-default-export
export const getCustomers = (stationId, page) => {
  return async (dispatch) => {
    dispatch({
      type: ActionType.FETCH_CUSTOMERS_START,
      payload: { page }
    });

    try {
      // send request to get all customers
      const response = await axios.get(`/customer/${stationId}?page=${page}`);
      const { data } = response.data.data;

      dispatch({
        type: ActionType.FETCH_CUSTOMERS_SUCCESS,
        payload: {
          data,
          total: response.data.data.total,
          per_page: response.data.data.per_page
        } // response data
      });
    } catch (error) {
      let message = '';

      if (error?.response) {
        if (Array.isArray(error.response.data?.message)) {
          message = error.response.data.message.join('\n');
        } else {
          message = error?.response.data?.message;
        }
      }
      if (!message) {
        message = 'Something went wrong';
      }
      dispatch({
        type: ActionType.FETCH_CUSTOMERS_ERROR,
        payload: message
      });
    }
  };
};

export const getRetailers = (stationId, page) => {
  return async (dispatch) => {
    dispatch({
      type: ActionType.FETCH_RETAILERS_START,
      payload: { page }
    });

    try {
      // send request to get all customers
      const response = await axios.get(`/customer/retailers/${stationId}?page=${page}`);
      const { data } = response.data.data;

      dispatch({
        type: ActionType.FETCH_RETAILERS_SUCCESS,
        payload: {
          data,
          total: response.data.data.total,
          per_page: response.data.data.per_page
        } // response data
      });
    } catch (error) {
      const message = detectError(error);

      dispatch({
        type: ActionType.FETCH_RETAILERS_ERROR,
        payload: message
      });
    }
  };
};

export const getEndUsers = (stationId, page) => {
  return async (dispatch) => {
    dispatch({
      type: ActionType.FETCH_ENDUSERS_START,
      payload: { page }
    });

    try {
      // send request to get all customers
      const response = await axios.get(`/customer/endusers/${stationId}?page=${page}`);
      const { data } = response.data.data;

      dispatch({
        type: ActionType.FETCH_ENDUSERS_SUCCESS,
        payload: {
          data,
          total: response.data.data.total,
          per_page: response.data.data.per_page
        } // response data
      });
    } catch (error) {
      const message = detectError(error);

      dispatch({
        type: ActionType.FETCH_ENDUSERS_ERROR,
        payload: message
      });
    }
  };
};

export const searchCustomers = (stationId, query) => {
  return async (dispatch) => {
    dispatch({
      type: ActionType.FETCH_CUSTOMER_SEARCH_START
    });

    try {
      // send request to get all customers
      const response = await axios.get(`/search/customer/${query}/${stationId}`);
      const { data } = response.data;

      const result = [];

      data.data.forEach((item) => {
        result.push({
          customer_id: item.customer_id,
          firstname: item.firstname,
          lastname: item.lastname,
          phone: item.phone,
          email: item.email,
          customer_type: item.customer_type
        });
      });

      dispatch({
        type: ActionType.FETCH_CUSTOMER_SEARCH_SUCCESS,
        payload: {
          data: result
        }
      });
    } catch (error) {
      const message = detectError(error);

      dispatch({
        type: ActionType.FETCH_CUSTOMER_SEARCH_ERROR,
        payload: message
      });
    }
  };
};

export const setCustomerView = (view) => {
  return async (dispatch) => {
    dispatch({
      type: ActionType.SET_CUSTOMER_VIEW,
      payload: { view }
    });
  };
};
